import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { Reveal, MaskedLines } from "@/components/Reveal";
import { IMAGES } from "@/lib/site";

export default function DreamHome() {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-12%", "12%"]);

  return (
    <section ref={ref} className="relative h-[80vh] min-h-[560px] overflow-hidden" data-testid="dream-home-section">
      <motion.img
        src={IMAGES.dream}
        alt="Contemporary home glowing at twilight"
        loading="lazy"
        style={{ y }}
        className="absolute inset-0 w-full h-[124%] object-cover"
      />
      <div className="absolute inset-0 bg-ink/60" />

      <div className="relative z-10 h-full max-w-[1440px] mx-auto px-5 sm:px-8 lg:px-12 flex flex-col items-center justify-center text-center">
        <MaskedLines
          className="font-serif font-medium tracking-tight leading-[1.05] text-cream text-4xl sm:text-5xl lg:text-7xl max-w-4xl"
          lines={[<>Your Block Is Unique.</>, <>Your Home Should Be <span className="italic text-gradient">Too.</span></>]}
        />
        <Reveal delay={0.25}>
          <p className="mt-7 max-w-2xl text-cream/85 text-[15px] sm:text-lg leading-relaxed font-light">
            Whether you're starting with a blank canvas or an unconventional block of land, ArcView
            Homes works with you to turn your ideas into a home designed around the way you want to
            live.
          </p>
          <a
            href="#contact"
            data-testid="dreamhome-cta-talk-about-home"
            className="mt-9 inline-flex items-center justify-center gap-3 border border-cream/60 text-cream font-semibold text-[15px] px-8 py-4 rounded-full hover:bg-cream hover:text-ink transition-all duration-300"
          >
            Let's Talk About Your Home
          </a>
        </Reveal>
      </div>
    </section>
  );
}
